import React from 'react';
import { useSelector } from 'react-redux';

import ExpiryReasons from './expiryReasons';
import ScheduledTours from './scheduledTours';


function getPageForRoute(key: string) {

    const selected = {
        'expiry-reasons': <ExpiryReasons />,
        'scheduled-tours': <ScheduledTours />,
    }[key];

    if (selected) { return selected; }
    return <div style={{ marginLeft: "20px", marginTop: "20px" }}>This page is not available yet</div>
}

function getKeyFromPath(path: string) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const ModulesIndex = () => {
    const page: string = useSelector((state: any) => state.router.location.pathname);

    return getPageForRoute(getKeyFromPath(page));
}

export default ModulesIndex;
